module.exports = __webpack_public_path__ + "static/media/IB_grades.bf2d1359.png";